import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { BranchComponent } from '../branch/branch.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-branch-list',
  templateUrl: './branch-list.component.html',
  styleUrls: ['./branch-list.component.css']
})
export class BranchListComponent implements OnInit {

  public menu_item_id = '5';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['branch_name', 'branch_name_en', 'country_name', 'city_name', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<BranchComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'branch', 'branch_name': '', 'branch_name_en': '', 'country_name': '', 'city_name': '' };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }



  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {

    let condition = "";

    if (this.model['branch_name'] != '')
      condition = " (`branch`.`branch_name` LIKE '%" + this.model['branch_name'] +
        "%' OR `branch`.`branch_name_en` LIKE '%" + this.model['branch_name'] + "%') AND ";
    let query = "SELECT `branch`.*, `city`.`city_name`, `country`.`country_name`, `country`.`country_id` FROM `branch`, `city`, `country` WHERE" + condition +
      " `branch`.`city_id` = `city`.`city_id` AND `city`.`country_id` = `country`.`country_id` AND `branch`.`status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newBranch() {
    this.addDialogRef = this.dialog.open(BranchComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['status'] == 'success')
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  editBranch(row) {
    let dialog_data = [{
      'table_name': 'branch', 'branch_id': row.branch_id,
      'company_id': row.company_id,
      'branch_name': row.branch_name,
      'branch_name_en': row.branch_name_en,
      'branch_address': row.branch_address,
      'city_id': row.city_id,
      'branch_email': row.branch_email,
      'branch_site': row.branch_site,
      'branch_tel': row.branch_tel,
      'branch_tel2': row.branch_tel2,
      'responsible': row.responsible,
      'responsible_phone': row.responsible_phone,
      'currency_id': row.currency_id,
      'comment': row.comment
    }, { 'country_id': row.country_id }];
    this.addDialogRef = this.dialog.open(BranchComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });

  }

  delBranch(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'branch_id': row.branch_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          //console.log(data);
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }

  }

}
